export default (state, _action) => {
  return {
    ...state,
    promoCodes: {
      ...state.promoCodes,
      isAdding: false,
    },
    waiting: false,
  };
};
